<template>
    <section>
    <div class="div-block-1232">
      <div class="w-layout-blockcontainer container-19 w-container">
        <a href="#" class="w-inline-block"><img sizes="84.03125px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-212"></a>
      </div>
      <div class="div-block-1205">
        <div class="text-block-271">You are all set  {{ first_name }}!</div>
        <p class="paragraph-70">Your Doctor&#x27;s Appointment time:<br><span class="text-span-189">{{getDate}} </span></p>
        <div>
          <div class="div-block-1206"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-213">
            <div class="text-block-272">Doctor Visit will take 15-20 minutes.</div>
          </div>
          <div class="div-block-1206"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-213">
            <div class="text-block-272">Make sure to check your email for more info.</div>
          </div>
          <div class="div-block-1206"><img loading="lazy" src="@/assets/images/icon_check_lime.svg" alt="" class="image-213">
            <div class="text-block-272">Your meds will be at your door in 3-5 Days.</div>
          </div>
        </div>
        <a href="/home"  class="button-50 w-button"><span class="text-span-188">Log in to Dashboard</span></a>
      </div>
    </div>
  </section>
</template>

<script>

import moment from 'moment-timezone';
export default {
    name: 'HelloWorld',
    props: ['baseUrl'],
    components: {
      
    },
    data() {
        return {
            selTime: "",
            setDate: '',
        }
    },
    computed:{
        first_name(){
            try{
                let k = localStorage.getItem("user_form");
                if(k){
                    let temp = JSON.parse(k);
                    return temp.first_name;
                }
            }catch(error){
                console.log(error);
                
            }
            return "";
        },
        getDate() {
            try{
                return moment(this.setDate.date).tz(this.setDate.timezone).format('MMMM Do, YYYY @ hh:mm A z')
            }catch(error){
                console.log(error)
                return "";
            }
            
        }
    },
    created() {
        try{
            this.setDate = JSON.parse(localStorage.getItem("app_slot"));
            }catch(error){
                console.log(error)
            }
        
    }
}
</script>